export enum RecruitmentPathTestVersion {
    VER_1 = 1,
    VER_2 = 2,
}